const r = {
  styleOverrides: {
    paper: ({ theme: o }) => ({
      borderRadius: o.tokens.radius[8],
      boxShadow: o.tokens.shadow.small
    }),
    list: ({ theme: o }) => ({
      border: `1px solid ${o.palette.other.outlinedBorder}`,
      borderRadius: o.tokens.radius[8]
    })
  }
};
export {
  r as menu
};
//# sourceMappingURL=menu2.mjs.map
